import { schoolTokenAxios } from "../axios";

const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;

let studentBulk_url = `${SCHOOL_BASE}/studentBulk`;

export const bulkUpdateStudentAcademicInfo = (body) => {
  return schoolTokenAxios.put(
    `${studentBulk_url}/bulkUpdateStudentAcademicInfo`,
    body
  );
};

export const getBulkAdmissionForStudentJsonFormat = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkAdmissionForStudentJsonFormat`
  );
};
export const getBulkUploadStudenttransportInfoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudenttransportInfoJson`
  );
};

export const bulkRegisterFreshStudent = async (payload, chunkSize = 100) => {
  const { session, students } = payload;

  const chunkedStudents = [];
  for (let i = 0; i < students.length; i += chunkSize) {
    chunkedStudents.push(students.slice(i, i + chunkSize));
  }

  const responses = [];
  for (const chunk of chunkedStudents) {
    try {
      const response = await schoolTokenAxios.post(
        `${studentBulk_url}/bulkRegisterFreshStudent`,
        { session, students: chunk }
      );
      responses.push(response?.data); // Store only the response data
    } catch (error) {
      console.error("Error sending chunk:", error);
      // Handle error for the chunk
      responses.push({
        success: false,
        message: `Error from Student ${chunk[0].firstName} to ${
          chunk[chunk.length - 1]?.firstName
        }: ${error.response?.data?.message || error.message} `,
        data: null,
      });
      // Optionally, you can break the loop or continue based on your needs
      // break; // Uncomment this line to stop processing on error
      // continue; // Uncomment this line to skip to the next chunk
      // You can also choose to throw an error or return a specific response
    }
  }

  // Return a single aggregated response
  return {
    success: true,
    message: "All chunks processed successfully",
    data: responses, // Include all responses
  };
};

export const bulkUpdateStudentTransportInfo = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentTransportInfo`,
    payload
  );
};

//bulkPromoteStudent
export const bulkPromoteStudent = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkPromoteStudent`,
    payload
  );
};

//bulkPromoteByClass
export const bulkPromoteByClass = (payload) => {
  return schoolTokenAxios.put(`${studentBulk_url}/bulkPromoteByClass`, payload);
};

//bulkUpdateStudentSr
export const bulkUpdateStudentSr = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentSr`,
    payload
  );
};

//bulkUpdateStudentPersonalInfo
export const bulkUpdateStudentPersonalInfo = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentPersonalInfo`,
    payload
  );
};

//bulkUpdateStudentPreviousSchoolInfo
export const bulkUpdateStudentPreviousSchoolInfo = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentPreviousSchoolInfo`,
    payload
  );
};

//bulkUpdateStudentHouseInfo
export const bulkUpdateStudentHouseInfo = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentHouseInfo`,
    payload
  );
};

//bulkUpdateStudentHostelInfo
export const bulkUpdateStudentHostelInfo = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentHostelInfo`,
    payload
  );
};

//bulkUpdateStudentprofilePhoto
export const bulkUpdateStudentProfilePhoto = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentProfilePhoto`,
    payload
  );
};

//bulkUpdateStudentDocumentInfo
export const bulkUpdateStudentDocumentInfo = (payload) => {
  return schoolTokenAxios.post(
    `${studentBulk_url}/bulkUpdateStudentDocumentInfo`,
    payload
  );
};

//getBulkUploadStudentPersonalInfoJson
export const getBulkUploadStudentPersonalInfoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudentPersonalInfoJson`
  );
};

//getBulkUploadStudentPreviousSchoolInfoJson
export const getBulkUploadStudentPreviousSchoolInfoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudentPreviousSchoolInfoJson`
  );
};

//getBulkUploadStudentHostelInfoJson
export const getBulkUploadStudentHostelInfoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudentHostelInfoJson`
  );
};

//getBulkUploadStudentHouseInfoJson
export const getBulkUploadStudentHouseInfoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudentHouseInfoJson`
  );
};

//getBulkUploadStudentProfilePhotoJson
export const getBulkUploadStudentProfilePhotoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudentProfilePhotoJson`
  );
};

//getBulkUploadStudentDocumentInfoJson
export const getBulkUploadStudentDocumentInfoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudentDocumentInfoJson`
  );
};

//getBulkUploadStudenttransportInfoJson
export const getBulkUploadStudentTransportInfoJson = () => {
  return schoolTokenAxios.get(
    `${studentBulk_url}/getBulkUploadStudentTransportInfoJson`
  );
};
